import './index.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Project from "./Pages/Project";
import Contact from "./Pages/Contact";
import TermsandConditions from "./Pages/TermsandConditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import SignUp from "./Pages/AllAuth/Auth/SignUp";
import { ToastContainer } from "react-toastify";
import UserSignUp from "./Pages/AllAuth/UserAuth/UserSignUp";
import UserLogin from "./Pages/AllAuth/UserAuth/UserLogin";
import AddRequirement from "./Pages/Requirement/User/AddRequirement";
import Profile from './Pages/Profile';
import ForgotPassword from './Pages/AllAuth/UserAuth/ForgotPassword';
import RequirementDetail from './Pages/Requirement/User/RequirementDetail';
import LoginSelection from './Pages/AllAuth/LoginSelection';
import SelectProfessionalTypeLogin from './Pages/AllAuth/SelectProfessionalTypeLogin';
import ContractorLogin from './Pages/AllAuth/ProfessionalLogin/ContractorLogin';
import SupplierLogin from './Pages/AllAuth/ProfessionalLogin/SupplierLogin';
import FreelancerLogin from './Pages/AllAuth/ProfessionalLogin/FreelancerLogin';
import LabourLogin from './Pages/AllAuth/ProfessionalLogin/LabourLogin';
import ContractorSignup from './Pages/AllAuth/ContractorSignup/ContractorSignup';
import SupplierSignUp from './Pages/AllAuth/SupplierSignUp/SupplierSignUp';
import FreelancerSignUp from './Pages/AllAuth/FreelancerSignUp/FreelancerSignUp';
import LabourSignUp from './Pages/AllAuth/LabourSignUp/LabourSignUp';
import SignUpSelection from './Pages/AllAuth/SighUpSelection';
import SelectProfessionalTypeSignUp from './Pages/AllAuth/SelectProfessionalTypeSignUp';
import UserAddFreelancerJobPost from './Pages/Requirement/UserFreelancer/UserAddFreelancerJobPost';
import UserAddMaterialRequest from './Pages/Requirement/UserMaterialSupplier/UserAddMaterialRequest';
import UserAddLabourJobPost from './Pages/Requirement/UserLabour/UserAddLabourJobPost';
import FreelancerAddMaterialRequest from './Pages/Freelancer/MaterialSupply/FreelancerAddMaterialRequest';
import FreelancerAddLabourJobPost from './Pages/Freelancer/HireLabour/FreelancerAddLabourJobPost';
import ContractorAddFreelancerJobPost from './Pages/Contractor/FreelancerJobPost/ContractorAddFreelancerJobPost';
import ContractorAddLabourJobPost from './Pages/Contractor/Labour/ContractorAddLabourJobPost';
import AboutUs from './Pages/AboutUs';
import ScrollToTop from './Components/ScrollToTop';


function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          {/* <Route path="/v2" element={<Project />} /> */}
          <Route path="/contact" element={<Contact />} />

          <Route path="/ph-ambassador" element={<SignUp />} />
          <Route path="/ph-ambassador/:id" element={<SignUp />} />

          {/* Professional SignUp */}
          <Route path="/SignUpSelection" element={<SignUpSelection />} />
          <Route path="/SelectProfessionalTypeSignUp" element={<SelectProfessionalTypeSignUp />} />

          <Route path="/ph-ContractorSignup" element={<ContractorSignup />} />
          <Route path="/ph-SupplierSignUp" element={<SupplierSignUp />} />
          <Route path="/ph-FreelancerSignUp" element={<FreelancerSignUp />} />
          <Route path="/ph-LabourSignUp" element={<LabourSignUp />} />

          {/* Professional Logins */}
          <Route path="/LoginSelection" element={<LoginSelection />} />
          <Route path="/SelectProfessionalTypeLogin" element={<SelectProfessionalTypeLogin />} />

          <Route path="/ph-ContractorLogin" element={<ContractorLogin />} />
          <Route path="/ph-SupplierLogin" element={<SupplierLogin />} />
          <Route path="/ph-FreelancerLogin" element={<FreelancerLogin />} />
          <Route path="/ph-LabourLogin" element={<LabourLogin />} />


          <Route path="/ph-UserSignUp" element={<UserSignUp />} />
          <Route path="/ph-UserLogin" element={<UserLogin />} />
          <Route path="/ph-forgotpassword" element={<ForgotPassword />} />
          <Route path="/AddRequirement" element={<AddRequirement />} />
          <Route path="/UserAddFreelancerJobPost" element={<UserAddFreelancerJobPost />} />
          <Route path="/UserAddMaterialRequest" element={<UserAddMaterialRequest />} />
          <Route path="/UserAddLabourJobPost" element={<UserAddLabourJobPost />} />

          <Route path="/ContractorAddFreelancerJobPost" element={<ContractorAddFreelancerJobPost />} />
          <Route path="/ContractorAddLabourJobPost" element={<ContractorAddLabourJobPost />} />

          <Route path="/FreelancerAddMaterialRequest" element={<FreelancerAddMaterialRequest />} />
          <Route path="/FreelancerAddLabourJobPost" element={<FreelancerAddLabourJobPost />} />

          <Route path="/profile" element={<Profile />} />
          <Route path="/RequirementDetail/:id" element={<RequirementDetail />} />

          <Route path="/terms" element={<TermsandConditions />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
